var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_285_17)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 56C43.4638 56 56 43.4638 56 28C56 12.536 43.4638 0 28 0C12.536 0 0 12.536 0 28C0 43.4638 12.536 56 28 56ZM40.6848 21.085C41.505 20.2649 41.505 18.9352 40.6848 18.1151C39.8647 17.295 38.5353 17.295 37.7152 18.1151L25.2 30.6303L21.0849 26.5151C20.2648 25.695 18.9352 25.695 18.1151 26.5151C17.295 27.3352 17.295 28.665 18.1151 29.4848L23.7151 35.0848C24.1089 35.4788 24.6431 35.7 25.2 35.7C25.7569 35.7 26.2911 35.4788 26.6849 35.0848L40.6848 21.085Z",
    fill: "#36AF10",
    fillOpacity: 0.84
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_285_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessLogo);
export default __webpack_public_path__ + "static/media/success-logo.43dd143fad28e1f27cfe3730c081d4d7.svg";
export { ForwardRef as ReactComponent };